import { User } from "@/types/Users";
import UserActionBlock from "./UserActionBlock";
import UserActionModal from "@/components/Modals/UserActionModal";
import { FC, useState } from "react";
import { AuthService } from "@/api/auth";
import { useSnackbar } from "notistack";
import { usePermissions } from "@/hooks/usePermissions";
import LoggingAPI from "@/api/logging";

interface ResetUserPasswordBlockProps {
  userData: User;
  onSubmit: () => void;
}

const ResetUserPasswordBlock: FC<ResetUserPasswordBlockProps> = ({
  userData,
  onSubmit,
}) => {
  const { currentUser } = usePermissions();
  const { enqueueSnackbar } = useSnackbar();

  const [showResetPasswordModal, setShowResetPasswordModal] = useState(false);

  const handleSubmit = async () => {
    if (!userData?.email) {
      enqueueSnackbar(
        "An error occurred resetting user password: invalid email.",
        {
          variant: "error",
        }
      );
      console.log("An error occurred resetting user password: invalid email.");
      return;
    }
    AuthService.resetPasswordRequest({ email: userData?.email });
    enqueueSnackbar("Password reset email has been sent to user.", {
      variant: "success",
    });

    LoggingAPI.createLog({
      user_id: currentUser.user_id,
      message: `Password reset email sent: ${userData?.email}`,
      event: "user:reset_password",
      object_type: "user",
    });
    onSubmit();
  };

  return (
    <>
      <UserActionBlock
        title="Reset Password"
        tooltip="Send a password reset email to the user."
        buttonProps={{
          primaryText: "Reset Password",
          action: () => setShowResetPasswordModal(true),
        }}
      />
      <UserActionModal
        show={showResetPasswordModal}
        onCancel={() => setShowResetPasswordModal(false)}
        onClose={() => setShowResetPasswordModal(false)}
        onSubmit={handleSubmit}
        title="Reset Password"
        body="Would you like to send a password reset email to the user?"
        buttonProps={{
          submitText: "Send Reset Email",
        }}
      />
    </>
  );
};

export default ResetUserPasswordBlock;
